import { render, staticRenderFns } from "./ProfWeightPanel.vue?vue&type=template&id=07408bb8"
import script from "./ProfWeightPanel.vue?vue&type=script&lang=js"
export * from "./ProfWeightPanel.vue?vue&type=script&lang=js"
import style0 from "./ProfWeightPanel.vue?vue&type=style&index=0&id=07408bb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VExpansionPanel,VExpansionPanelHeader,VTextField})
